import { Tooltip } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import BestValueBadge from '@/components/PlatformSubscription/BestValueBadge';
import {
  planHeaderHeight,
  PlanHeaderTitleClass,
} from '@/components/PlatformSubscription/PlanTable';
import {
  columnWidth,
  columnWidthSmall,
} from '@/components/PlatformSubscription/PlanTable/Columns';
import Pricing from '@/components/PlatformSubscription/PlanTable/Columns/HeaderCell/Pricing';
import ButtonDefault, {
  ButtonVariants,
} from '@/components/shared/basic/button';

interface Props {
  classes?: {
    headerClass?: string;
    divClass?: string;
    bestValueClass?: string;
  };
  title?: string;
  price?: string;
  priceCut?: string;
  buttonTitle?: string;
  expText?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  disabled?: boolean;
  bestValue?: boolean;
  buttonTooltip?: string;
}

const HeaderCell: FC<Props> = ({
  expText,
  classes,
  price,
  priceCut,
  title,
  buttonTitle,
  onClick,
  disabled = false,
  bestValue = false,
  buttonTooltip,
}) => {
  const screens = useBreakpoint();

  return (
    <div
      style={{
        width: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
        maxWidth: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
      }}
      className='flex flex-col justify-between flex-1'
    >
      <div
        className={twMerge(
          'bg-primary/15 flex items-center justify-center px-3',
          classes?.headerClass,
        )}
        style={{ height: planHeaderHeight }}
      >
        <p className={`${PlanHeaderTitleClass}`}>{title}</p>
      </div>
      {bestValue ? (
        <div
          className={twMerge(
            `flex items-center justify-center pt-6`,
            classes?.bestValueClass,
          )}
        >
          <BestValueBadge
            classes={{
              parantClass: 'bg-gradient-to-b from-[#CD4FF2] to-[#5F4AFF] ',
              textParant: 'bg-[#170F33] ',
            }}
          />
        </div>
      ) : null}

      <div
        className={twMerge(
          'xl:px-6 px-4 flex-1 flex flex-col justify-end ',
          classes?.divClass,
        )}
      >
        <Pricing
          classes={{
            price: 'xl:text-[32px] text-xl',
            priceCut: 'xl:text-2xl text-base',
          }}
          price={price}
          priceCut={priceCut}
        />
        <Tooltip title={buttonTooltip}>
          <ButtonDefault
            disabled={disabled}
            onClick={onClick}
            className='w-full px-6 py-[9px] text-sm font-semibold leading-[22px] mb-4 disabled:bg-grayZl-900 disabled:text-grayZl-700'
            size={0}
            variant={ButtonVariants.PRIMARY}
          >
            {buttonTitle}
          </ButtonDefault>
        </Tooltip>
        {expText ? (
          <p className='mb-4 italic text-center text-success-400 xl:text-sm text-xs font-medium leading-[22px]'>
            {expText}
          </p>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default HeaderCell;
